export default __webpack_public_path__ + "static/Graphik-LightItalic-Web-c99a5b9ab461714436cad852ffe5c62c.ttf";